import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { copyOf2ng0t8oizk6it as copyOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { LIST_getInstance2leq5bbahk4rz as LIST_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var TombstoneClass;
function Tombstone() {
  if (TombstoneClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Tombstone');
    TombstoneClass = $;
  }
  return TombstoneClass;
}
var Tombstone_instance;
function Tombstone_getInstance() {
  return Tombstone_instance;
}
var RedactedKeyClass;
function RedactedKey() {
  if (RedactedKeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'RedactedKey');
    RedactedKeyClass = $;
  }
  return RedactedKeyClass;
}
var RedactedKey_instance;
function RedactedKey_getInstance() {
  return RedactedKey_instance;
}
function resize($this) {
  var newSize = imul($this.f2t_1, 2);
  $this.d2t_1 = copyOf($this.d2t_1, newSize);
  var tmp = 0;
  var tmp_0 = new Int32Array(newSize);
  while (tmp < newSize) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var newIndices = tmp_0;
  // Inline function 'kotlin.collections.copyInto' call
  var this_0 = $this.e2t_1;
  var endIndex = this_0.length;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = this_0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp_1, newIndices, 0, 0, endIndex);
  $this.e2t_1 = newIndices;
}
var JsonPathClass;
function JsonPath() {
  if (JsonPathClass === VOID) {
    class $ {
      constructor(configuration) {
        this.c2t_1 = configuration;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.d2t_1 = Array(8);
        var tmp_0 = this;
        var tmp_1 = 0;
        var tmp_2 = new Int32Array(8);
        while (tmp_1 < 8) {
          tmp_2[tmp_1] = -1;
          tmp_1 = tmp_1 + 1 | 0;
        }
        tmp_0.e2t_1 = tmp_2;
        this.f2t_1 = -1;
      }
      g2t(sd) {
        this.f2t_1 = this.f2t_1 + 1 | 0;
        var depth = this.f2t_1;
        if (depth === this.d2t_1.length) {
          resize(this);
        }
        this.d2t_1[depth] = sd;
      }
      h2t(index) {
        this.e2t_1[this.f2t_1] = index;
      }
      i2t(key) {
        var tmp;
        if (!(this.e2t_1[this.f2t_1] === -2)) {
          this.f2t_1 = this.f2t_1 + 1 | 0;
          tmp = this.f2t_1 === this.d2t_1.length;
        } else {
          tmp = false;
        }
        if (tmp) {
          resize(this);
        }
        this.d2t_1[this.f2t_1] = this.c2t_1.x2o_1 ? key : RedactedKey_instance;
        this.e2t_1[this.f2t_1] = -2;
      }
      j2t() {
        if (this.e2t_1[this.f2t_1] === -2) {
          this.d2t_1[this.f2t_1] = Tombstone_instance;
        }
      }
      k2t() {
        var depth = this.f2t_1;
        if (this.e2t_1[depth] === -2) {
          this.e2t_1[depth] = -1;
          this.f2t_1 = this.f2t_1 - 1 | 0;
        }
        if (!(this.f2t_1 === -1)) {
          this.f2t_1 = this.f2t_1 - 1 | 0;
        }
      }
      l2t() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1('$');
        // Inline function 'kotlin.repeat' call
        var times = this.f2t_1 + 1 | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = this.d2t_1[index];
            if (!(element == null) ? isInterface(element, SerialDescriptor()) : false) {
              if (equals(element.w1p(), LIST_getInstance())) {
                if (!(this.e2t_1[index] === -1)) {
                  this_0.m1('[');
                  this_0.ug(this.e2t_1[index]);
                  this_0.m1(']');
                }
              } else {
                var idx = this.e2t_1[index];
                if (idx >= 0) {
                  this_0.m1('.');
                  this_0.m1(element.a1q(idx));
                }
              }
            } else {
              if (element === RedactedKey_instance) {
                this_0.m1('[<debug info disabled>]');
              } else {
                if (!(element === Tombstone_instance)) {
                  this_0.m1('[');
                  this_0.m1("'");
                  this_0.s1(element);
                  this_0.m1("'");
                  this_0.m1(']');
                }
              }
            }
          }
           while (inductionVariable < times);
        return this_0.toString();
      }
      toString() {
        return this.l2t();
      }
    }
    initMetadataForClass($, 'JsonPath');
    JsonPathClass = $;
  }
  return JsonPathClass;
}
//region block: init
Tombstone_instance = new (Tombstone())();
RedactedKey_instance = new (RedactedKey())();
//endregion
//region block: exports
export {
  JsonPath as JsonPath2hoqh4ysli693,
};
//endregion

//# sourceMappingURL=JsonPath.mjs.map
